import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  dynamicClear,
  dynamicRequest,
  set_ui_module_component_role_access_mutation,
  useDynamicSelector,
} from "@services/redux";
import CheckBoxComponent from "../checkbox/checkbox";

const PageComponentRoleCheckBox = (props) => {
  const { page_component, role } = props;
  const dispatch = useDispatch();

  const { id, status, loading } = useDynamicSelector(
    `setUiModuleComponentRoleAccess-${page_component.id}-${role.id}`
  );
  const [has_access, setHasAccess] = useState(false);

  useEffect(() => {
    if (page_component) {
      let page_roles = page_component.roles.map((x) => x.id);
      if (page_roles.indexOf(role.id) > -1) {
        setHasAccess(true);
      } else {
        setHasAccess(false);
      }
    }
  }, [page_component]);

  useEffect(() => {
    if (status === "success" && id === page_component.id) {
      setHasAccess(!has_access);
      dispatch(
        dynamicClear(
          `setUiModuleComponentRoleAccess-${page_component.id}-${role.id}`
        )
      );
    }
  }, [status]);

  const onChangePageAccess = (value) => {
    if (!loading) {
      let keys = [
        {
          key: "setUiModuleComponentRoleAccess",
          loading: true,
          variant: `${page_component.id}-${role.id}`,
        },
      ];
      let variables = {
        id: page_component.id,
        role_id: role.id,
        has_access: value,
      };
      dispatch(
        dynamicRequest(
          keys,
          set_ui_module_component_role_access_mutation,
          variables,
          "M"
        )
      );
    }
  };

  return (
    <CheckBoxComponent
      is_checked={has_access}
      loading={loading}
      onChange={onChangePageAccess}
    />
  );
};
export default PageComponentRoleCheckBox;
